import React, { useContext, useEffect, useState } from 'react'

import moment from 'moment'

import clsx from 'clsx'

import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  LinearProgress
} from '@material-ui/core'

import DateFnsUtils from '@date-io/date-fns'
import ptBR from 'date-fns/locale/pt-BR'

import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import ButtonGZ from '../../components/Button'
import TextAreaHtml from '../../components/TextAreaHtml'
import useStyles from './styles'

import Context from '../../context'
import { addOrEditNews, getThemesList } from '../../services/ClubeApi'
import ImageUploadToS3 from '../../services/ImageUpload'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function NewsForm(props) {
  // ##################
  const classes = useStyles()
  const { setAboutCurrentPage, setShowLoadingModal } = useContext(Context)
  const { user, setUser } = useContext(Context)
  const [selectedDate, setSelectedDate] = useState(moment().utc().toISOString())
  const [openSchedule, setOpenSchedule] = useState(false)
  // const [userRole, setUserRole] = useState(null);
  const data = props.location.state
  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)
  const [groupsData, setGroupsData] = useState([])
  let [associatedGroups, setAssociatedGroups] = useState([])
  const [formData, setFormData] = useState({
    ...data,
    title: data?.title || '',
    content: data?.content || '',
    image: data?.image || '',
    createdAt: data?.createdAt || '',
    author: data?.author || '',
    publishedDate: data?.publishedDate || moment()
    .utc()
    .toISOString(), // prettier-ignore
    whiteLabelNewsWhiteLabelList: data?.WhiteLabelNewsWhiteLabelLists || [
      { whiteLabelId: '', title: '', whiteLabelNewsId: '' }
    ]
  })

  // ##################
  useEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setUser(getLoggedUser)

    setSelectedDate(formData.publishedDate)
    const namePage = `${data ? 'Editar' : 'Novo'} post em Fique Ligado`
    setAboutCurrentPage({
      title: namePage,
      buttons: [{ title: 'Voltar', pathname: '/newslist' }]
    })
  }, [])

  // ##################
  useEffect(() => {
    try {
      // console.log('DATA', data);
      const whiteLabelList = data?.WhiteLabelNewsWhiteLabelLists || []
      const addAssociatedGroupList = whiteLabelList.map(item => {
        return {
          whiteLabelId: item.whiteLabelId,
          whiteLabelNewsId: formData.id,
          title: item.WhiteLabel.title
        }
      })
      setAssociatedGroups(addAssociatedGroupList)
      // console.log('List Associated', associatedGroups);

      if (user?.userGroup === 6) {
        // console.log('FORM DATA', formData);
        // console.log('USER GROUP 6', user);
        getThemesList().then(response => {
          const listWhiteLabel = response.map(group => {
            const matchedId = addAssociatedGroupList.some(item => item.whiteLabelId === group.id)
            return {
              id: group.id,
              title: group.title,
              associated: matchedId || false
            }
          })
          setGroupsData([
            ...listWhiteLabel,
            {
              id: user?.whiteLabelId,
              title: user?.WhiteLabel?.title,
              associated: true
            }
          ])
          // console.log('Groups', listWhiteLabel);
        })

        const isThereWhiteLabelId = addAssociatedGroupList.filter(
          item => item.whiteLabelId === user?.whiteLabelId
        )

        if (!isThereWhiteLabelId) {
          setAssociatedGroups([
            ...associatedGroups,
            {
              whiteLabelId: user?.whiteLabelId,
              whiteLabelNewsId: formData.id,
              title: user?.WhiteLabel.title
            }
          ])
        }

        // console.log('List Associated', associatedGroups);
        return
      }

      getThemesList().then(response => {
        const listWhiteLabel = response.map(group => {
          const matchedId = addAssociatedGroupList.some(item => item.whiteLabelId === group.id)
          return {
            id: group.id,
            title: group.title,
            associated: matchedId || false
          }
        })
        setGroupsData(listWhiteLabel)
        // console.log('Groups', listWhiteLabel);
      })
    } catch (err) {
      console.log(err)
    }
  }, [user])

  // ##################
  function handleChangeContent(field) {
    return function (event) {
      if (loading) return
      let newData = { ...formData }
      newData[field] = event.target.value
      setFormData(newData)
    }
  }

  // ##################
  function handleTextArea(value) {
    if (loading) return
    setFormData({ ...formData, content: value })
    // checkValue('content', value);
  }

  // ##################
  function handleDateChange(date) {
    setSelectedDate(moment(date).utc().toISOString())
    // console.log('Date: ', selectedDate);
  }

  // ##################
  function handleScheduled() {
    if (loading) return
    setFormData({ ...formData, publishedDate: selectedDate })
    schedule()
  }

  // ##################
  function handleWhiteLabelGroup(event, id) {
    const groupsDataNew = groupsData
    const addGroupsNew = groupsDataNew.map(group => {
      if (group.id === id) {
        return {
          ...group,
          associated: event.target.checked
        }
      } else {
        return group
      }
    })

    setGroupsData(addGroupsNew)
    // console.log(addGroupsNew);

    let checkListGroup = addGroupsNew
      .map(group => {
        if (group.associated) {
          return {
            whiteLabelId: group.id,
            title: group.title,
            whiteLabelNewsId: formData.id
          }
        }
      })
      .filter(group => !!group)
    // console.log('Updated: ', checkListGroup);
    setAssociatedGroups(checkListGroup)
  }

  // ##################
  async function handleImageChange(event) {
    if (loading || !event.target.files[0]) return

    setFormData({
      ...formData,
      image: event.target.files[0]
    })
    // console.log('Image loaded: ', formData);
  }

  // ##################
  function hideErrorsModal() {
    setErrors(null)
  }

  // ##################
  async function checkData() {
    let errors = []
    // Image
    if (!formData.image) errors.push('Sem imagem carregada')
    // Content
    if (!formData.title) errors.push('Você precisa fornecer um título')
    if (!formData.content) errors.push('Você precisa preencher algum conteúdo')

    // Groups
    if (!associatedGroups.length && (user.whiteLabelId == null || user.whiteLabelId === ''))
      errors.push('Selecione pelo menos um grupo')

    return errors.length === 0 ? false : errors
  }

  // ##################
  async function saveAsDraft() {
    let errors = await checkData()
    if (errors)
      return setErrors({
        list: errors,
        situation: 3
      })

    execute(3)
  }

  // ##################
  async function update() {
    let errors = await checkData()
    if (errors)
      return setErrors({
        list: errors,
        situation: 1
      })

    execute(1)
  }

  async function schedule() {
    let errors = await checkData()
    if (errors) {
      setOpenSchedule(false)
      return setErrors({
        list: errors,
        situation: 1
      })
    }

    execute(1)
  }

  // ##################
  async function execute(situation) {
    if (loading) return
    setShowLoadingModal(true)
    if (associatedGroups.length === 0 && !(user.whiteLabelId == null || user.whiteLabelId === '')) {
      const { title, id } = user.WhiteLabel
      associatedGroups = [{ whiteLabelId: id, title }]
    }
    try {
      setLoading(true)
      let finalData = {
        ...formData,
        whiteLabelNewsWhiteLabelList: associatedGroups,
        publishedDate: selectedDate || formData.publishedDate,
        situation
      }
      // console.log(finalData);
      if (finalData.image instanceof File) {
        let path = await ImageUploadToS3(finalData.image, 'images/news/')
        finalData.image = path
      }

      await addOrEditNews(finalData)
      setShowLoadingModal(false)
      props.history.push('/newslist')
    } catch (err) {
      setShowLoadingModal(false)
      console.log(err)
    }
  }

  // ##################

  return (
    <>
      {/* {console.log(formData)} */}
      <div className={classes.outerContainer}>
        <Grid item xs={12}>
          {loading ? <LinearProgress marginTop="15px" /> : null}
        </Grid>
        <div className={classes.content}>
          <div className={classes.main}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <Grid className={classes.inputGroup}>
                  <span>Título do post*</span>
                  <input value={formData.title} onChange={handleChangeContent('title')} required />
                </Grid>
                <Grid className={clsx(classes.inputGroup, classes.editor)}>
                  <span>Conteúdo do post*</span>
                  <TextAreaHtml
                    handleEditor={handleTextArea}
                    value={formData.content}
                    rows="15"
                    required
                  />
                </Grid>
                <Grid className={classes.inputGroup}>
                  <span>Autor do post</span>
                  <input value={formData.author} onChange={handleChangeContent('author')} />
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid item>
                  <div className={classes.box}>
                    <h4>Adicionar imagem destacada</h4>
                    <Grid item>
                      <Grid item flexDirection="column">
                        <Grid container>
                          <label style={{ flex: 1 }}>
                            {formData.image ? (
                              <img
                                className={classes.img}
                                src={(image =>
                                  image instanceof File
                                    ? URL.createObjectURL(image)
                                    : process.env.REACT_APP_IMAGES_URL + image)(formData.image)}
                              />
                            ) : null}
                            <span className={classes.plainButton}>Selecionar arquivo</span>
                            <input
                              className={classes.hiddenInput}
                              type="file"
                              accept="image/png"
                              onChange={handleImageChange}
                            />
                          </label>
                        </Grid>
                        <Grid container justify="center">
                          <span className={classes.legend}>Arquivo .png/.jpg/.jpeg</span>
                        </Grid>
                      </Grid>
                      <Grid item className={classes.inputGroup} style={{ padding: 0 }}>
                        <Grid container justify="center">
                          <span>Legenda da imagem</span>
                        </Grid>
                        <Grid container>
                          <input
                            style={{ flex: 1 }}
                            value={formData.legend}
                            onChange={handleChangeContent('legend')}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>

                <Grid item className={clsx({ [classes.hide]: user?.userGroup === 6 })}>
                  <div className={classes.box}>
                    <h4>Empresas</h4>
                    <div>
                      <ul>
                        {/* {console.log(user?.userGroup)}
                        {console.log(formData)} */}
                        {groupsData?.map(group => (
                          <li key={group.id}>
                            <FormControlLabel
                              value="start"
                              checked={group.associated}
                              onChange={ev => handleWhiteLabelGroup(ev, group.id)}
                              control={<Checkbox />}
                              label={group.title}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justify="center"
                  alignItems="flex-start"
                  spacing={2}
                >
                  <Grid contaier direction="row" justify="center" alignItems="flex-start">
                    {!data?.publishedDate && (
                      <Grid item xs={12} style={{ padding: '10px 0' }}>
                        <button
                          className={classes.plainButton}
                          onClick={() => setOpenSchedule(true)}
                          type="button"
                        >
                          Agendar Publicação
                        </button>
                      </Grid>
                    )}
                    {!data?.situation === 3 || !data?.publishedDate ? (
                      <Grid item xs={12} style={{ padding: '10px 0' }}>
                        <button
                          type="button"
                          onClick={saveAsDraft}
                          className={clsx(
                            {
                              [classes.hide]: data?.situation === 3
                            },
                            classes.plainButton
                          )}
                        >
                          Salvar Rascunho
                        </button>
                      </Grid>
                    ) : (
                      ''
                    )}
                  </Grid>

                  <Grid item xs={5}>
                    <ButtonGZ fullWidth variant="main" onClick={update}>
                      {!!data && data.situation === 1 ? 'Atualizar' : 'Publicar'}
                    </ButtonGZ>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Verificação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul className={classes.ul}>
              {errors?.list?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Deseja continuar mesmo assim?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideErrorsModal}>
            Não
          </ButtonGZ>
          <ButtonGZ color="primary" onClick={() => execute(errors?.situation)}>
            Sim
          </ButtonGZ>
        </DialogActions>
      </Dialog>
      {/* AGENDAMENTO */}
      <Dialog
        open={openSchedule}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Agendar Publicação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
              <Grid container justify="space-around">
                <DateTimePicker
                  autoOk
                  label="Selecione a data"
                  inputVariant="standard"
                  ampm={false}
                  format="d/MM/yyyy HH:mm"
                  disablePast
                  value={selectedDate}
                  onChange={date => handleDateChange(date)}
                  // onAccept={date => setSelectedDate(date)}
                  // views={['date', 'year', 'month', 'hours', 'minutes']}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={() => setOpenSchedule(false)}>
            Cancelar
          </ButtonGZ>
          <ButtonGZ color="primary" onClick={handleScheduled}>
            Agendar
          </ButtonGZ>
        </DialogActions>
      </Dialog>
      {/* {console.log(selectedDate)}
      {console.log(formData)} */}
    </>
  )
}

export default NewsForm
